import * as ApiInstanceInjector from '@/shared/js/services/api/ApiInstanceInjector'

import api from '@/services/Api'

// passes the api instance on the MetricsService shared Api service
ApiInstanceInjector.setApi(api)
